/**
 * Entry point for backend plugin.
 * Consists of various types of API initializers.
 */

'use strict';

module.exports = {
    /** Initialization of API provider for application. */
    onAppInit: require('./modules/app.api.provider'),
    /** Initialization of API provider for external (Prime Launcher for now) subscriber. */
    onContentBoardInit: require('./modules/launcher.api.provider')
};
